import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PaginatedResults } from '../../models/paginated_results_model';
import { PaginationOptions } from '../../models/pagination_options';
import { LoadingBay } from '../../models/loading-bay';

@Injectable({
  providedIn: 'root',
})
export class LoadingBayService {
  currentDomain = environment.currentApiHostname;
  apiUrl = `https://${this.currentDomain}/api/general`;

  constructor(private http: HttpClient) {}

  get(paginationOptions: PaginationOptions) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<PaginatedResults>(
      this.apiUrl +
        `/loading-bays?${PaginationOptions.getPaginationQueryParameters(
          paginationOptions
        )}`,
      options
    );
  }

  all() {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<Array<LoadingBay>>(
      this.apiUrl + `/loading-bays/index/all`,
      options
    );
  }

  allByWarehouse(warehouseUuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<Array<LoadingBay>>(
      this.apiUrl + `/loading-bays/index/all/by-warehouse/${warehouseUuid}`,
      options
    );
  }

  export(type: string, paginationOptions: PaginationOptions) {
    const options = {
      responseType: 'blob' as 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get(
      this.apiUrl +
        `/exports/loading-bays/export/${type}?${PaginationOptions.getPaginationQueryParameters(
          paginationOptions
        )}`,
      options
    );
  }

  show(uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<LoadingBay>(
      this.apiUrl + `/loading-bays/${uuid}`,
      options
    );
  }

  store(payload: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<LoadingBay>(
      this.apiUrl + `/loading-bays`,
      payload,
      options
    );
  }

  update(payload: any, uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<LoadingBay>(
      this.apiUrl + `/loading-bays/update/${uuid}`,
      payload,
      options
    );
  }
}
